import React from 'react';
import {Helmet} from 'react-helmet/es/Helmet';

class SEO extends React.Component {
  render() {
    const {title, metaTitle, metaDescription, metaKeywords, featuredImage, author, noFollow} = this.props;
    const siteUrl = window.location.href;
    const siteTitle = title === undefined ? metaTitle : title;

    return (
        <Helmet>
          <meta charSet="utf-8"/>
          <title>{siteTitle}</title>
          <meta name="title" content={metaTitle}/>
          <meta name="description" content={metaDescription}/>
          <meta name="keywords" content={metaKeywords}/>
          <meta name="robots" content={noFollow === undefined ?
              'index, follow' :
              'noindex, nofollow'}/>
          <meta name="Classification" content="Business"/>
          <meta name="author" content={author === undefined ?
              'Dr Naveen Kumar, dr.naveen@medcampus.io' :
              author}/>
          <meta name="reply-to" content="support@medcampus.io"/>
          <meta name="url" content="https://wwww.medcampus.io"/>
          <meta name="identifier-URL" content="https://wwww.medcampus.io"/>
          <meta name="directory" content="submission"/>
          <meta name="category" content="Education"/>
          <meta name="coverage" content="Worldwide"/>
          <meta name="distribution" content="Global"/>
          <meta name="language" content="English"/>
          {/*Twitter Tags*/}
          <meta name="twitter:card" content="summary"/>
          <meta name="twitter:site" content="@campus_med"/>
          <meta name="twitter:url" content={siteUrl}/>
          <meta name="twitter:title" content={metaTitle}/>
          <meta name="twitter:description" content={metaDescription}/>
          <meta name="twitter:creator" content="@campus_med"/>
          <meta name="twitter:image"
                content={featuredImage === undefined ? '' : featuredImage}/>
          {/*Open Graph / Facebook */}
          <meta property="og:title" content={metaTitle}/>
          <meta property="og:type" content="article"/>
          <meta property="og:url" content={siteUrl}/>
          <meta property="og:image"
                content={featuredImage === undefined ? '' : featuredImage}/>
          <meta property="og:description" content={metaDescription}/>
          <meta property="og:site_name" content="MedCampus"/>
        </Helmet>
    );
  }
}

export {SEO};
